import { Modal, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { AddButtonLink } from '@/core/components';

import { ReclaimableAuthorList } from '@feature/utils/components/ReclaimableAuthorList';

import { ProjectReclaimSearch, ReclaimRequest } from './model/ProjectTypes';

interface ProjectFoundModalProps {
  close: () => void;
  data: ProjectReclaimSearch;

  onReclaimAuthorship: (v: ReclaimRequest) => void;
}

export function ProjectFoundModal({ close, data, onReclaimAuthorship }: ProjectFoundModalProps) {
  const { project } = data;
  const { t } = useTranslation();

  return (
    <Modal
      opened
      onClose={close}
      centered
      size="lg"
      title={project != null && t('projects.foundPub')}
    >
      {project == null && (
        <Stack>
          <Text ta="center">{t('publications.notSearchFound')}</Text>
          <AddButtonLink
            to="../create"
            name={t('button.addNew')}
          />
        </Stack>
      )}
      {project != null && (
        <Stack>
          <Text fw="500">{project.title}</Text>
          <ReclaimableAuthorList
            authors={project.authors}
            onReclaim={authorId => onReclaimAuthorship({ authorId, projectId: project.id })}
          />
        </Stack>
      )}
    </Modal>
  );
}
